import { useInView } from '../../hooks/useInView'
import { GOALS, reachGoal } from '../../lib/metrika'

/**
 * Юридические документы. PDF лежат в public/pdf и отдаются с нашего домена —
 * копии тех, что опубликованы на about.ris.promo.
 * «Требования Минцифры к сайтам ИТ-компаний» убирать нельзя: раскрытие этой
 * информации на официальном сайте обязательно для аккредитованной ИТ-компании
 * (приказ Минцифры от 02.06.2025 № 511).
 */
const DOCS = [
  { href: '/pdf/privacy.pdf', label: 'Политика конфиденциальности' },
  { href: '/pdf/processing_of_personal_data.pdf', label: 'Согласие на обработку персональных данных' },
  { href: '/pdf/it_agreement.pdf', label: 'Требования Минцифры к сайтам ИТ-компаний' },
]

export function Footer() {
  const { ref, inView } = useInView(0.05, '0px 0px -20px 0px')
  return (
    <footer ref={ref} className={`mx-auto flex max-w-[1920px] flex-col items-center gap-6 px-4 pt-6 pb-10 sm:px-6 lg:px-[7%] reveal${inView ? ' in-view' : ''}`}>
      {/* Тонкий fade-разделитель сверху */}
      <div
        className="h-px w-full max-w-[1000px]"
        style={{
          background:
            'radial-gradient(ellipse 500px 1px at center, rgba(149,149,155,0.4) 0%, rgba(230,230,230,0) 100%)',
        }}
      />
      <div className="flex w-full flex-col items-center gap-4 lg:flex-row lg:justify-between">
        <p className="font-body text-[16px] leading-6 text-ink-500">
          © 2026 RIS.Promo
        </p>

        {/* Документы — одной строкой мелким шрифтом. На узких экранах строка
            переносится по ссылкам целиком, разделители не осиротеют. */}
        <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 lg:justify-end">
          {DOCS.map(({ href, label }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => reachGoal(GOALS.docOpen, { doc: label })}
              className="font-body whitespace-nowrap text-[13px] leading-5 text-[#8a8f9e] underline decoration-from-font transition-colors hover:text-[#5c6376]"
            >
              {label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  )
}
